/* @flow */
import { getEventPlugins } from '@braindate/domain/lib/event/util';

import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';
import useEventDefaultTheme from 'src/shared/domain/event/hook/useEventDefaultTheme';
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import { customFontPlugin } from 'src/shared/app/feature/settings/featureSettings';
import { getTheme } from 'src/shared/app/base/settings/themeSettings';

export default function useCreateBaseStyleProps() {
  const [accentColor] = useEventAccentColor();
  const { useLightTheme, isCustomFontEnabled } = useFeatureDecisions();
  const event = useEvent();
  const plugin = getEventPlugins(event)[customFontPlugin];
  const customFontFamily =
    event && isCustomFontEnabled ? plugin && plugin.font_family : null;
  const themeName = useEventDefaultTheme();
  const theme = getTheme(themeName, accentColor, customFontFamily);
  return {
    theme,
    ...theme,
    withLightTheme: useLightTheme,
  };
}
